var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions" },
    [
      _c("Button", {
        directives: [
          {
            name: "b-popover",
            rawName: "v-b-popover.hover.blur.top",
            value: "Редактировать",
            expression: "'Редактировать'",
            modifiers: { hover: true, blur: true, top: true },
          },
        ],
        staticClass: "edit",
        attrs: { icon: "edit", size: "iconic" },
        on: {
          click: function ($event) {
            return _vm.$emit("edit", _vm.entry)
          },
        },
      }),
      _vm.canEdit
        ? _c("Button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.hover.blur.top",
                value: "Удалить",
                expression: "'Удалить'",
                modifiers: { hover: true, blur: true, top: true },
              },
            ],
            staticClass: "remove",
            attrs: {
              icon: { icon: "trash", color: "secondary" },
              size: "iconic",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("remove", _vm.entry)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }